var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogoutBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Conference Room"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.21408 1.33545L7.28102 1.34659L12.9477 2.67992C13.151 2.72775 13.3006 2.89578 13.3285 3.09805L13.3332 3.16663V12.8333C13.3332 13.0421 13.2039 13.2262 13.0134 13.2997L12.9477 13.32L7.28102 14.6533C6.98959 14.7219 6.70952 14.5215 6.671 14.2343L6.6665 14.1666V1.83329C6.6665 1.55693 6.8874 1.3425 7.14816 1.33337L7.21408 1.33545ZM7.6665 2.4646V13.5353L12.3332 12.4373V3.56264L7.6665 2.4646ZM5.99984 2.66663V3.66663H3.6665V12.3333H5.99984V13.3333H3.1665C2.91337 13.3333 2.70418 13.1452 2.67107 12.9011L2.6665 12.8333V3.16663C2.6665 2.9135 2.85461 2.7043 3.09866 2.67119L3.1665 2.66663H5.99984ZM9.33317 7.33329C9.70136 7.33329 9.99984 7.63177 9.99984 7.99996C9.99984 8.36815 9.70136 8.66663 9.33317 8.66663C8.96498 8.66663 8.6665 8.36815 8.6665 7.99996C8.6665 7.63177 8.96498 7.33329 9.33317 7.33329Z",
    fill: "#222729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoutBlack);
export default __webpack_public_path__ + "static/media/icon-logout-black.0ac9372d042660cef0bdf548d318352a.svg";
export { ForwardRef as ReactComponent };